import type { ReactNode } from "react";

interface AuthProviderProps {
  children: ReactNode;
}

// BetterAuth has no concept of a Provider as a higher-order component
// Session management is handled via cookies and the auth API
export function AuthProvider({ children }: AuthProviderProps) {
  return children;
}
